module.exports = __webpack_public_path__ + "static/service-boundary-1-b744a921c24a8a8b619221fdb8c35e0a.png";